import React from 'react';

import { isAlert, NormalizedThreshold } from '../utils/metrics';

interface DotProps {
  cx?: number;
  cy?: number;
  value?: number;
  stroke?: string;
}

export const createAnomalyDot = (threshold: NormalizedThreshold) => {
  return ({ cx, cy, value, stroke }: DotProps) => {
    if (cx == null || cy == null || value == null || !isAlert(threshold, value)) return null;
    return <circle cx={cx} cy={cy} r={5} fill="white" stroke={stroke} strokeWidth={2} />;
  };
};
